// extracted by mini-css-extract-plugin
export default {"highlight":"formik-form-control_highlight__pz7t-"};